import { createSlice } from '@reduxjs/toolkit';
import { createUser, deleteUserById, fetchAllAdminUser, updateUser } from './userManagementThunk';
import { API_STATUS_TYPE } from '../../../utils/contants';

const INITIAL_VALUE = {
  isLoading: false,
  adminUsers: [],
  status: 'idle',
  error: null
};

const userManagementSlice = createSlice({
  name: 'user-management',
  initialState: INITIAL_VALUE,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllAdminUser.pending, (state, action) => {
        state.isLoading = true;
        state.status = API_STATUS_TYPE.PENDING;
      })
      .addCase(fetchAllAdminUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
        state.adminUsers = action.payload.data || []
      })

      /// Adding User
      .addCase(createUser.pending, (state, action) => {
        state.isLoading = true;
        state.status = API_STATUS_TYPE.PENDING;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
      })

      /// Updating User
      .addCase(updateUser.pending, (state, action) => {
        state.isLoading = true;
        state.status = API_STATUS_TYPE.PENDING;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
      })

    .addCase(deleteUserById.pending, (state, action) => {
        state.isLoading = true;
        state.status = API_STATUS_TYPE.PENDING;
      })
      .addCase(deleteUserById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
      })

      ///Handling rejection for all the API's
      .addMatcher(
        (action) => action.type.endsWith('/rejected'),
        (state, action) => {
          state.isLoading = false;
          state.status = API_STATUS_TYPE.FAILED;
          state.error = action?.payload?.error;
        }
      );
  }
});


export const {} = userManagementSlice.actions
export default userManagementSlice.reducer